import React from 'react';

const NotFound: React.FC = () => {
  return <h1>404 - Page Not Found</h1>;
};

export default NotFound;